module.exports = __webpack_public_path__ + "ba5bcdc03e36dd4cc76619b927fb1aad.png";